import renderConfirmationView from './confirmationView.js';
import getOffsetTop from './getOffsetTop.js';
import { getDocName } from './doctorMethods.js';
import { submitLabel } from './templates/doctors.js';

module.exports = renderPatientView;

function getAptData(aptObj) {
  const aptDate = moment.parseZone(aptObj.start_time).format('dddd, MMMM Do YYYY');
  const aptTime = moment.parseZone(aptObj.start_time).format('h:mm a');
  const docName = getDocName(aptObj.doctor_id);
  return { aptDate, aptTime, docName};
}

function updateAptDate(aptObj) {
  const aptData = getAptData(aptObj);
  $('#submit-button-label').html(submitLabel(aptData));
}

function createPatientForm(aptObj) {
  const aptData = getAptData(aptObj);
  //Wrappers for Patient Info Section
  const $patientInfoRow = $(document.createElement('div'))
    .attr('id', 'patient-info-row')
    .addClass('row');
  const $patientInfoWrapper = $(document.createElement('div'))
    .attr('id', 'patient-info-wrapper')
    .addClass('col-12 centered-wrapper');
  const $patientInfoHeader = $(document.createElement('div'))
    .addClass('col-12 pb-title')
    .html('Patient Information')
    .attr('id', 'patient-info-header');


  const $form = $(document.createElement('form'))
    .attr('id', 'patient-info-form')
    .addClass('font-md')
    .attr('action', '/book')
    .attr('method', 'post')
    .attr('novalidate', 'novalidate');


  //******Input Elements and Labels in Form******

  //First Name
  const $firstNameLabel = $(document.createElement('label'))
    .attr('id', 'first-name-label')
    .attr('for', 'first-name')
    .html('First Name:');
  const $firstName = $(document.createElement('input'))
    .attr('id', 'first-name')
    .attr('name', 'firstName')
    .attr('type', 'text')
    .prop('required', true)
    .attr('placeholder', 'First Name');
  const $firstNameWrapper = $wrapper('first-name-wrapper',
    $firstNameLabel, $star(), $br(), $firstName);

  //Last Name
  const $lastNameLabel = $(document.createElement('label'))
    .attr('id', 'last-name-label')
    .attr('for', 'last-name')
    .html('Last Name:');
  const $lastName = $(document.createElement('input'))
    .attr('id', 'last-name')
    .attr('name', 'lastName')
    .attr('type', 'text')
    .prop('required', true)
    .attr('placeholder', 'Last Name');
  const $lastNameWrapper = $wrapper('last-name-wrapper',
    $lastNameLabel, $star(), $br(), $lastName);

  //Phone Number
  const $phoneNumberLabel = $(document.createElement('label'))
    .attr('id', 'phone-number-label')
    .attr('for', 'phone-number')
    .html('Primary Phone Number:');
  const $phoneNumber = $(document.createElement('input'))
    .attr('id', 'phone-number')
    .attr('name', 'phoneNumber')
    .attr('type', 'tel')
    .prop('required', true)
    .attr('placeholder', '888-123-4567')
    .on('change keyup paste', formatPhoneNumber)
    .attr('pattern', '^([0-9]{3})-([0-9]{3})-([0-9]{4})$');
  const $phoneNumberWrapper = $wrapper('phone-number-wrapper',
    $phoneNumberLabel, $star(), $br(), $phoneNumber);

  //Email Address
  const $emailLabel = $(document.createElement('label'))
    .attr('id', 'email-label')
    .attr('for', 'email')
    .html('Email Address:');
  const $email = $(document.createElement('input'))
    .attr('id', 'email')
    .attr('name', 'email')
    .attr('type', 'email')
    .prop('required', true)
    .attr('placeholder', 'someone@example.com');
  const $emailWrapper = $wrapper('email-wrapper',
    $emailLabel, $star(), $br(), $email);

  // DOB
  const $dobLabel = $(document.createElement('label'))
    .attr('id', 'dob-label')
    .attr('for', 'dob')
    .html('Date of Birth:');
  const $dob = $(document.createElement('input'))
    .attr('id', 'dob')
    .attr('name', 'dob')
    .attr('type', 'text')
    .attr('placeholder', '01/31/1973');
  const $dobWrapper = $wrapper('dob-wrapper',
    $dobLabel, $br(), $dob);

  //Current Patient? (y/n)
  const $currentPatientLabel = $(document.createElement('label'))
    .attr('id', 'current-patient-label')
    .attr('for', 'current-patient')
    .html('Are you a current patient?');
  const $currentPatient = $(document.createElement('select'))
    .attr('id', 'current-patient')
    .attr('name', 'currentPatient')
    .prop('required', true);
  const $currentPatientYes = $(document.createElement('option'))
    .attr('value', 'Yes')
    .html('Yes');
  const $currentPatientNo = $(document.createElement('option'))
    .attr('value', 'No')
    .html('No');

  $currentPatient.append($(document.createElement('option')),
    $currentPatientYes, $currentPatientNo);

  const $currentPatientWrapper = $wrapper('current-patient-wrapper',
    $currentPatientLabel, $star(), $br(), $currentPatient);


  //Reason for Appointment
  const $reasonLabel = $(document.createElement('label'))
    .attr('id', 'reason-label')
    .attr('for', 'reason')
    .html('What is the reason for your appointment?');
  const $reason = $(document.createElement('select'))
    .attr('id', 'reason')
    .attr('name', 'reason')
    .prop('required', true);
  const $reason1 = $(document.createElement('option'))
    .attr('value', 'Vision and eye health exam for glasses wearer')
    .html('Vision and eye health exam for glasses wearer');
  const $reason2 = $(document.createElement('option'))
    .attr('value', 'Vision and eye health exam for contact and glasses wearer')
    .html('Vision and eye health exam for contact and glasses wearer');
  const $reason3 = $(document.createElement('option'))
    .attr('value', 'Dry eye evaluation')
    .html('Dry eye evaluation');
  const $reason4 = $(document.createElement('option'))
    .attr('value', 'Medical concern')
    .html('Medical concern');
  const $reason5 = $(document.createElement('option'))
    .attr('value', 'Other')
    .html('Other');

  $reason.append($(document.createElement('option')),
    $reason1, $reason2, $reason3, $reason4, $reason5);

  const $reasonWrapper = $wrapper('reason-wrapper',
    $reasonLabel, $star(), $br(), $reason);


  //Type of Insurance
  const $insuranceLabel = $(document.createElement('label'))
    .attr('id', 'insurance-label')
    .attr('for', 'insurance')
    .html('What kind of insurance do you have?');
  const $insurance = $(document.createElement('select'))
    .attr('id', 'insurance')
    .attr('name', 'insurance')
    .prop('required', true);
  const $insurance1 = $(document.createElement('option'))
    .attr('value', 'None')
    .html('None');
  const $insurance2 = $(document.createElement('option'))
    .attr('value', 'VSP')
    .html('VSP');
  const $insurance3 = $(document.createElement('option'))
    .attr('value', 'EyeMed')
    .html('EyeMed');
  const $insurance4 = $(document.createElement('option'))
    .attr('value', 'Spectera')
    .html('Spectera');
  const $insurance5 = $(document.createElement('option'))
    .attr('value', 'Other')
    .html('Other');

  $insurance.append($insurance1, $insurance2, $insurance3, $insurance4, $insurance5);

  const $insuranceWrapper = $wrapper('insurance-wrapper',
    $insuranceLabel, $star(), $br(), $insurance);

  // Insurance Member ID
  const $insuranceMemberIDLabel = $(document.createElement('label'))
    .attr('id', 'insurance-member-id-label')
    .attr('for', 'insurance-member-id')
    .html('Insurance Member ID:');
  const $insuranceMemberID = $(document.createElement('input'))
    .attr('id', 'insurance-member-id')
    .attr('name', 'insuranceMemberID')
    .attr('placeholder', '12345678');
  const $insuranceMemberIDWrapper = $wrapper('insurance-member-id-wrapper',
    $insuranceMemberIDLabel, $br(), $insuranceMemberID);


  //Appointment Concerns/Notes
  const $concernsLabel = $(document.createElement('label'))
    .attr('id', 'concerns-label')
    .attr('for', 'concerns')
    .html('What concerns, if any, would you like to speak to the doctor about:');
  const $concerns = $(document.createElement('textarea'))
    .attr('id', 'concerns')
    .attr('name', 'concerns')
    .attr('form', 'patient-info-form');
  const $concernsWrapper = $wrapper('concerns-wrapper',
    $concernsLabel, $br(), $concerns);


  //Submit Button
  const $submitButtonWrapper = $(document.createElement('div'))
    .addClass('centered-wrapper')
    .attr('id', 'submit-button-wrapper');
  const $submitButtonLabel = $(document.createElement('label'))
    .attr('id', 'submit-button-label')
    .html(submitLabel(aptData));
  const $submitButton = $(document.createElement('input'))
    .attr('type', 'submit')
    .attr('id', 'submit-button')
    .addClass('purple-button main-button')
    .attr('value', 'REQUEST');
  $submitButtonWrapper.append($submitButtonLabel, $br(), $submitButton);

  //Append Visible Elements
  $form.append(
    $firstNameWrapper,
    $lastNameWrapper,
    $phoneNumberWrapper,
    $emailWrapper,
    $dobWrapper,
    $currentPatientWrapper,
    $reasonWrapper,
    $insuranceWrapper,
    $insuranceMemberIDWrapper,
    $concernsWrapper,
    $submitButtonWrapper
  );


  //Hidden Inputs Obtained from Appointment Object
  const $startTime = $(document.createElement('input'))
    .attr('name', 'startTime')
    .attr('value', aptObj.start_time)
    .attr('hidden', true);
  const $endTime = $(document.createElement('input'))
    .attr('name', 'endTime')
    .attr('value', aptObj.end_time)
    .attr('hidden', true);


  //Append Hidden Elements
  $form.append($startTime, $endTime);

  //Attach Submit Event Listener;
  $form.submit(submitForm);

  //Attach form to Page
  $patientInfoRow.append($patientInfoWrapper);
  $patientInfoWrapper.append($patientInfoHeader, $form);
  $('#main').append($patientInfoRow);
}

function renderPatientView(aptObj) {
  const aptDate = moment.parseZone(aptObj.start_time).format('dddd, MMMM Do YYYY');
  const aptTime = moment.parseZone(aptObj.start_time).format('h:mm a');

  //Delete Existing Patient View (if one exists) to prevent duplicates
  if ($('#patient-info-row').length > 0) {
    updateAptDate(aptObj);
  } else {
    createPatientForm(aptObj);
  }

  const $patientInfoRow = document.querySelector('#patient-info-row');

  //Scroll to Patient Info Section
  if (window.innerWidth < 576) {
    const target = getOffsetTop($patientInfoRow);
    $('#content').animate({
      scrollTop: target
    }, 600);
  } else {
    $('html, body').animate({
      scrollTop: $($patientInfoRow).offset().top
    }, 600);
  }
}






//Helper Functions to Create Repeated Elements
function $br() {
  return $(document.createElement('br'));
}

function $star() {
  return $(document.createElement('span'))
    .addClass('star')
    .html(' *');
}

function $wrapper(id, ...elements) {
  const output = $(document.createElement('div'))
    .addClass('input-wrapper')
    .attr('id', id);
  output.append(...elements);
  return output;
}


//Formats the Phone Number Input Field
function formatPhoneNumber(event) {
  let output;
  let input = $("#phone-number").val();
  input = input.replace(/[^0-9]/g, '');
  const area = input.substr(0, 3);
  const pre = input.substr(3, 3);
  const tel = input.substr(6, 4);
  if (area.length < 3) {
    output = area;
  } else if (area.length == 3 && pre.length >= 0 && pre.length < 3) {
    output = area + '-' + pre;
  } else if (area.length == 3 && pre.length == 3) {
    output = area + '-' + pre + '-' + tel;
  }

  const charCode = (event.which) ? event.which : event.keyCode;
  const isBackSpace = charCode === 8;
  if (isBackSpace && output.charAt(output.length - 1) === '-') {
    output = output.substring(0, output.length - 1);
  }

  $("#phone-number").val(output);
};

function checkForm() {
  const inputs = document.querySelector('#patient-info-form').elements;
  for (var i = 0; i < inputs.length; i++) {
    if (!inputs[i].validity.valid) {
      const $errorMsg = $(document.createElement('div'))
        .addClass('pb-error-msg');

      if (inputs[i].validity.valueMissing) {
        $errorMsg.html('This field is required');
      } else {
        switch (inputs[i].name) {
          case 'email':
            $errorMsg.html('Please enter a valid email address.');
            break;
          case 'phoneNumber':
            $errorMsg.html('Please enter a valid phone number.');
            break;
          default:
            $errorMsg.html('The information you have entered is not valid.');
        }
      }

      $(inputs[i]).parent().addClass('error').append($errorMsg);
    }
  }

  const isValid = document.querySelector('#patient-info-form').checkValidity();
  return isValid;
}


function clearErrors() {
  $('.pb-error-msg').remove();
  $('.input-wrapper.error').removeClass('error');
}


//Triggered when the for is submitted
function submitForm(e) {
  e.preventDefault();

  clearErrors();



  //Formats object to be send to server with form data
  const formData = $(e.target).serializeArray().reduce((accum, curr) => {
    accum[curr.name] = curr.value;
    return accum;
  }, {});

  const isValid = checkForm();

  if (!isValid) {
    return false;
  }

  formData.phoneNumber = formData.phoneNumber.replace(/[^0-9]/g, '');
  formData.doctor_id = window.PB.doc._id;
  const business_id = $('#business-data').attr('data-business-id');
  const location_id = $('#business-data').attr('data-location-id');

  $.ajax({
    url: `/book/business_id/${business_id}/location_id/${location_id}`,
    type: 'POST',
    data: formData,
    success: (data) => {
      renderConfirmationView();
    },
    error: (err) => {
      console.log('error during submitting form');
      $('#submit-button').removeClass('disabled');
      $('#submit-button').prop('disabled', false);
    }
  });

  $('#submit-button').addClass('disabled');
  $('#submit-button').prop('disabled', true);
}



// WEBPACK FOOTER //
// ./public/src/patientView.js